import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from "react-router-dom";
import CommonConfig from "../../../utils/constant";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { useCatchResponse } from '../../../utils/useCatchResponse';


const GraceMarks = () => {
    const { catchResponse } = useCatchResponse();
    const [searchTerm, setSearchTerm] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [coScholasticOnGoingGradesList, setGraceMarksOnGoingGradesList] = useState([]);
    const [coScholasticCompletedGradesList, setGraceMarksCompletedGradesList] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClassName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };
    const filteredExams = (activeTab === 1 ? coScholasticCompletedGradesList : coScholasticOnGoingGradesList).filter(x =>
        x?.ClassName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        x?.TermName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        GetGraceMarksList(loginData?._id, loginData?.CreatedBy);
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const GetGraceMarksList = async (id, schId) => {
        try {
            let data = {
                UserID: id,
                SchoolId: schId
            }
            Loader.show();
            await api.post(APIConstant.path.GetGraceMarksMasterDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    var onGoingList = res?.data;
                    var completeList = res?.data;
                    setGraceMarksOnGoingGradesList(onGoingList);
                    setGraceMarksCompletedGradesList(completeList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const actionTemplate = (rowData) => (
        <Button label="Grace Marks" disabled={rowData?.TotalStudents == '0' ? true : false} onClick={(e) => navigate('/grace-marks-entry', { state: { className: rowData?.ClassName, classId: rowData?.ClassId, termId: rowData?.TermId } })} />
    );

    const srNoBodyTemplate = (data, props) => {
        return props?.rowIndex + 1;
    };

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-book"></i>
                    <h2>Grace Marks</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <div className="e-tab-main">
                <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                    <TabPanel header="Ongoing">
                        <DataTable value={filteredExams} paginator
                            rows={rows}
                            first={first}
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            rowsPerPageOptions={[5, 10, 20]}
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            onPage={onPageChange}
                            className='custom-table'
                            scrollHeight='calc(100vh - 175px)'
                            size='small'
                        >
                            <Column header="Sr No" body={srNoBodyTemplate} style={{ maxWidth: "10%" }} />
                            <Column field="ClassName" header="Class" style={{ maxWidth: "20%" }} />
                            <Column field="TotalStudents" header="No. of Students Require GM" style={{ maxWidth: "17%" }} />
                            <Column field="TermName" header="Term" style={{ maxWidth: "20%" }} />
                            <Column header='Action' body={actionTemplate} style={{ maxWidth: "10%" }} />
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="Completed">
                        <DataTable value={filteredExams} paginator
                            rows={rows}
                            first={first}
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            rowsPerPageOptions={[5, 10, 20]}
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            onPage={onPageChange}
                            className='custom-table'
                            scrollHeight='calc(100vh - 175px)'
                            size='small'
                        >
                            <Column header="Sr No" body={srNoBodyTemplate} style={{ width: "6%" }} />
                            <Column field="ClassName" header="Class" />
                            <Column field="TotalStudents" header="No. of Students Require GM" />
                            <Column field="TermName" header="Term" />
                            <Column header='Action' body={actionTemplate} />
                        </DataTable>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};

export default GraceMarks;
